import React from 'react';
import { View } from 'react-native';
import { useQuery } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { Fields, defaultValues, prepareInput, useFormSubmit } from 'app/src/elements/forms';
import { Button } from 'app/src/elements/buttons';
import { Loading } from 'app/src/elements/DataState';
import { Notice } from 'app/src/elements/Notice';
import { Title } from 'app/src/styles';
import { useNavigate } from 'app/src/utils/routing';

import { CREATE_THING, THINGS } from './queries';

export const FIELDS = {
  name: {
    label: 'Name',
    rules: { required: true },
  },
  parentId: {
    label: 'Parent',
    blank: 'null',
  },
  emoji: {
    label: 'Emoji',
    type: 'emoji',
  },
};

const NewThing = ({ onCreated }) => {
  const navigate = useNavigate();

  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: defaultValues({ fields: FIELDS })
  });

  const { data: selects } = useQuery(THINGS, {
    variables: { limit: 100000, offset: 'MA==', options: {} }
  });

  const { submit: createThing, formStatus, errorMessage } =
    useFormSubmit(CREATE_THING, {
      onCompleted: data => {
        if (onCreated) {
          onCreated(data.createThing.thing);
        } else {
          navigate('/things');
        }
      }
    });

  const onSubmit = input => {
    createThing({ variables: { input: prepareInput(input, FIELDS) } });
  };

  const fields = { ...FIELDS };

  if (selects) {
    fields.parentId.select = [
      { value: '', label: 'NONE' },
      ...selects.things.edges
        .map(edge => ({ value: edge.node.id, label: edge.node.name }))
    ];
  }

  return (
    <View>
      <Title>Add Thing</Title>

      <Fields
        fields={FIELDS}
        control={control}
        errors={errors}
      />

      {errorMessage && <Notice type="error">{errorMessage}</Notice>}

      {'submitting' === formStatus ? (
        <Loading />
      ) : (
        <Button label="Save" onPress={handleSubmit(onSubmit)} wide />
      )}
    </View>
  );
};

export default NewThing;
